// extracted by mini-css-extract-plugin
export default {"DictionaryContainer":"CareersStyle_DictionaryContainer__3hE2A","customTitleh1":"CareersStyle_customTitleh1__UtKhO"};